import { Container, TitleText, MessageText, MessageContainer, LogoContainer, LogoImg } from "./MessageCard.components";
import Loader20 from "components/Loader20";
import outputLogoStripes from "assets/images/output-logo-180x180.svg";
import { useTranslation } from "react-i18next";

interface MessageCardProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
}

function MessageCard(props: MessageCardProps) {
  const { t } = useTranslation();
  return (
    <>
      <Container>
        <MessageContainer>
          {props.title && (
            <TitleText variant="h1" pb={2}>
              {props.title}
            </TitleText>
          )}
          <MessageText variant="h3">
            <span>{props.children}</span>
          </MessageText>
        </MessageContainer>
        <LogoContainer>
          <LogoImg src={outputLogoStripes} alt={t("global.logo_stripes_alt_text")} />
        </LogoContainer>
      </Container>
      <Loader20 />
    </>
  );
}

export default MessageCard;
